import React, { Component } from "react";
import {
  fetchBasemapEsri_search,
  fetchShipTracker,
  fetchShipTrackerDel,
  fetchShipTrack,
  fetchVesselSearch
} from "../../api/portal";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { pushLoader } from "actions/main";
import {
  pushBasemap,
  pushDateVersion,
  pushPointShipTrack
} from "actions/portal";
import { pushLeftPanel } from "actions/dashboard";
import { pushPoiTarget, pushSourceAis } from "actions/portal";
import Radio from "@material-ui/core/Radio";
import Chip from "@material-ui/core/Chip";
import Typography from "@material-ui/core/Typography";

// core components
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import moment from "moment";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import FormLabel from "@material-ui/core/FormLabel";
import { withRouter } from "react-router-dom";

class contentBottompanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
      show: false,
      basmapesrilist: null,
      shiptracker: [],
      basemap: "female",
      date_version: moment().format("DD-MM-YYYY"),
      sourceAis: false,
      sourceGPS: true
    };
    this.handleTags = this.handleTags.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.props.pushDateVersion(moment().format("YYYYMMDD"));
    // fetchBasemapEsri_search(this.state.date_version)
    //   .then(response => {
    //     this.props.pushLoader(false);
    //     this.setState({ basmapesrilist: response.data.results });
    //   })
    //   .catch(error => {
    //     console.log(error);
    //   });
    fetchShipTracker(localStorage.getItem("id"))
      .then(response => {
        this.props.pushLoader(false);
        this.setState({ shiptracker: response.data.results });
      })
      .catch(error => {
        console.log(error);
        // this.props.history.push("/pages/login#logout");
      });
  }

  handleTags(regularTags) {
    this.setState({ tags: regularTags });
  }

  UNSAFE_componentWillReceiveProps() {
    fetchShipTracker(localStorage.getItem("id"))
      .then(response => {
        this.props.pushLoader(false);
        this.setState({ shiptracker: response.data.results });
      })
      .catch(error => {
        console.log(error);
        // this.props.history.push("/pages/login#logout");
      });
  }

  componentDidMount() {
    fetchShipTracker(localStorage.getItem("id"))
      .then(response => {
        this.props.pushLoader(false);
        this.setState({ shiptracker: response.data.results });
      })
      .catch(error => {
        console.log(error);
        // this.props.history.push("/pages/login#logout");
      });
  }

  renderlist(disData) {
    return (
      <FormControlLabel
        value={disData.basemap_url}
        control={<Radio />}
        label={disData.name}
      />
    );
  }

  handleChange = event => {
    this.setState({ basemap: event.target.value });
    this.props.pushBasemap(event.target.value);
  };

  handleChangeSourceAis = event => {
    if (!this.state.sourceAis == true) {
      this.props.pushSourceAis("AIS_MT");
    } else {
      this.props.pushSourceAis("GPS");
    }

    this.setState({ sourceAis: !this.state.sourceAis });
    this.setState({ sourceGPS: !this.state.sourceGPS });
  };
  handleChangeSourceGPS = event => {
    if (!this.state.sourceGPS == true) {
      this.props.pushSourceAis("GPS");
    } else {
      this.props.pushSourceAis("AIS_MT");
    }

    this.setState({ sourceGPS: !this.state.sourceGPS });
    this.setState({ sourceAis: !this.state.sourceAis });
  };

  handleDate = event => {
    let datenya = moment(event._d, "YYYY MMMM DD").format("YYYY-MM-DD");
    this.props.pushDateVersion(
      moment(event._d, "YYYY MMMM DD").format("YYYYMMDD")
    );
    //console.log(moment(event._d, 'YYYY MMMM DD').format("YYYY-MM-DD"));
    this.setState({ date_version: datenya });
    fetchBasemapEsri_search(datenya)
      .then(response => {
        this.props.pushLoader(false);
        this.setState({ basmapesrilist: response.data.results });
      })
      .catch(error => {
        console.log(error);
        // this.props.history.push("/pages/login#logout");
      });
  };

  handleLeftPanel = () => {
    //this.props.pushLeftPanel(!this.props.leftPanel);
  };

  renderShipTracker = e => {
    return (
      <Chip
        color="primary"
        label={e.name}
        onClick={() => {
          let lotlat = [];
          fetchShipTrack(e.ppid)
            .then(response => {
              response.data.map(ee => {
                lotlat.push([ee[4], ee[3]]);
              });
              this.props.pushPointShipTrack(lotlat.toString());
            })
            .catch(error => {
              console.log(error);
              // this.props.history.push("/pages/login#logout");
            });

          fetchVesselSearch(e.name)
            .then(response => {
              response.data.results.map(e => {
                this.props.pushPoiTarget([e.lat, e.lon]);
              });
            })
            .catch(error => {
              console.log(error);
              // this.props.history.push("/pages/login#logout");
            });
        }}
        onDelete={() => {
          fetchShipTrackerDel(e.id)
            .then(response => {
              fetchShipTracker(localStorage.getItem("id"))
                .then(response => {
                  this.props.pushLoader(false);
                  this.setState({ shiptracker: response.data.results });
                })
                .catch(error => {
                  console.log(error);
                  // this.props.history.push("/pages/login#logout");
                });
            })
            .catch(error => {
              console.log(error);
              // this.props.history.push("/pages/login#logout");
            });
        }}
        style={{
          color: "#FFF",
          backgroundColor: "#476FA1",
          borderRadius: "30px",
          fontWeight: "600",
          top: "5px"
        }}
      />
    );
  };

  render() {
    // if (this.state.basmapesrilist == null) {
    //   return false;
    // }

    return (
      <Grid
        container
        direction="row"
        justify="left"
        style={{ background: "rgb(255, 246, 246, 0.8)", height: "37px" }}
      >
        <GridItem xs={10}>
          {this.state.shiptracker.map(this.renderShipTracker)}
        </GridItem>
        {/*<GridItem xs={2}>
          <Button color="success" round onClick={this.handleLeftPanel}>
            <EqualizerIcon /> Analyticsss{" "}
          </Button>
        </GridItem>*/}
        {/* <GridItem xs={12} lg={2} style={{ display: "flex", flexDirection: "row", justifyContent: 'end' }}>
          <Typography style={{ paddingTop: "9px", marginRight: "5px" }}>
            Source:{" "}
          </Typography>

          <FormControlLabel
            control={
              <Checkbox
                checked={this.state.sourceGPS}
                onChange={this.handleChangeSourceGPS}
                name="checkedA"
                color="secondary"
              />
            }
            label="GPS"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={this.state.sourceAis}
                onChange={this.handleChangeSourceAis}
                name="checkedA"
                color="primary"
              />
            }
            label="AIS"
          />
        </GridItem> */}
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    blocking: state.loader,
    leftPanel: state.leftPanel
  };
}

contentBottompanel.propTypes = {
  classes: PropTypes.object.isRequired,
  pushLoader: PropTypes.bool,
  pushBasemap: PropTypes.string,
  pushDateVersion: PropTypes.string,
  pushPointShipTrack: PropTypes.array,
  pushLeftPanel: PropTypes.bool,
  leftPanel: PropTypes.bool,
  pushPoiTarget: PropTypes.array
};

export default withRouter(connect(
  mapStateToProps,
  {
    pushLoader,
    pushBasemap,
    pushDateVersion,
    pushLeftPanel,
    pushPoiTarget,
    pushPointShipTrack,
    pushSourceAis
  }
)(contentBottompanel));
